<template>
  <div class="page-sidebar" v-if="items && items.length > 0">
    <button
      v-for="(item, key) in items"
      :key="key"
      :disabled="isDisabled(key)"
      class="page-sidebar-button"
      type="button"
      @click="isDisabled(key) ? null : gotoSection(key)"
    >
      <span class="sign"></span>{{ item.name }}
    </button>
  </div>
  <p v-else>no side indicator items found</p>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

export default {
  name: "SideIndicator",
  props: {
    items: null,
    activeIndex: {
      default: 0
    }
  },
  components: {},
  computed: {},
  data() {
    return {};
  },
  methods: {
    gotoSection(sectionIndex){
      this.$emit('gotoSection', sectionIndex)
    },
    isDisabled(key){
      return key > this.activeIndex ? true : false
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

.page-sidebar {
  max-width: 250px;
  text-align: left;
  width: 100%;
  position: absolute;
  top: 20px;

  &-button {
    display: flex;
    background: linear-gradient(45deg, white, transparent);
    border: 0;
    width: 100%;
    text-align: left;
    padding: 10px 20px;
    font-weight: bold;
    align-items: center;

    &:disabled {
      opacity: 0.3;
    }

    & + button {
      margin-top: 2px;
    }
  }

  .sign {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: $secondary-color;

    &:before {
      content: "";
      width: 15px;
      display: block;
      flex-shrink: 0;
      height: 15px;
      border-radius: 50%;
      border: 1px solid $secondary-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/SideIndicator.vue